<template>
  <div id="insider-backtester-risk-mgmts-tab">
    <v-container fluid pa-0>
      <v-row>
        <!-- When to exit out of a position -->
        <v-col cols="12" mb-2>
          <helpers-section-sub-header
            >Use Volatility Adjusted Trade Sizing:</helpers-section-sub-header
          >
          <p>Volatility Adjusted Trade Sizing works as follows:</p>
          <ol>
            <li>
              The standard deviation of the S&P 500 (SPY) for a given timeframe is found and divided
              by the closing price of the SPY
            </li>
            <li>Step 1 is done for each stock that is being purchased</li>
            <li>
              Step 1 is divided by Step 2. This indicates how much more or less volatile the stock
              is versus the overall market
            </li>
            <li>
              The value from Step 3 is used to adjust the trade size. e.g. if normally backtester
              purchases 1,000 shares and the value multiplier is 0.5 (which indicates the stock is
              twice as volatile as the SPY) then the buy order would be risk-adjusted to 500 shares.
            </li>
          </ol>

          <v-row>
            <!-- When to exit out of a position -->
            <v-col cols="auto">
              <v-checkbox
                v-model="criteria.use_volatility_adjusted_trading_size"
                hide-details
                class="shrink mr-2 mt-0"
              />
            </v-col>
            <v-col cols="12" mb-2 sm="4" md="3" xl="2">
              <v-select
                v-model="criteria.volatility_adjusted_stddev_time"
                :items="risk_adjusted_times"
                :disabled="!criteria.use_volatility_adjusted_trading_size"
                item-title="text"
                hide-details
                label="STDDEV number of days"
              />
            </v-col>

            <v-col cols="12" sm="4" md="3" xl="2" align="end">
              <v-text-field
                v-model="criteria.volatility_min_ratio"
                :disabled="!criteria.use_volatility_adjusted_trading_size"
                type="number"
                label="Min ratio"
                hide-details
              />
            </v-col>
            <v-col :shrink="!$vuetify.display.xs" cols="12" mb-2 sm="4" md="3" xl="2">
              <v-text-field
                v-model="criteria.volatility_max_ratio"
                :disabled="!criteria.use_volatility_adjusted_trading_size"
                type="number"
                label="Max Ratio"
                hide-details
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  data() {
    return {
      risk_adjusted_times: [
        { value: 0, text: '1 week' },
        { value: 1, text: '1 month' }
      ]
    }
  },
  computed: {
    ...mapFields({
      criteria: 'app.insiderBacktesterCriteria'
    })
  }
}
</script>
